import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from './login.component';
import { SignupComponent } from './signup.component';
import { WelcomeComponent } from './welcome.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MainComponent } from './main.component';
import { DialogOpretUdstyrComponent } from './dialog-opret-udstyr.component';
import { MygearComponent } from './mygear.component';

import {MatDialogModule} from '@angular/material/dialog';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatButton, MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';



import { ShowgearComponent } from './showgear.component';
import { DialogShowFullImageComponent } from './dialog-show-full-image.component';
import { DialogEditUdstyrComponent } from './dialog-edit-udstyr.component';
import { PoolComponent } from './pool.component';
import { AdminComponent } from './admin.component';
import { DialogEditTextComponent } from './dialog-edit-text.component';
import { DialogEditUserComponent } from './admin/dialog-edit-user.component';
import { SendEmailComponent } from './reset/send-email.component';
import { ResetPasswordComponent } from './reset/reset-password.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignupComponent,
    WelcomeComponent,
    MainComponent,
    DialogOpretUdstyrComponent,
    MygearComponent,
    ShowgearComponent,
    DialogShowFullImageComponent,
    DialogEditUdstyrComponent,
    PoolComponent,
    AdminComponent,
    DialogEditTextComponent,
    DialogEditUserComponent,
    SendEmailComponent,
    ResetPasswordComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule
    
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
